export default {
  FETCH_DISCOUNT: (state, payload) => {
    state.discounts = payload
  },
  SET_GENERAL_DISCOUNT: (state, payload) => {
    state.generalDiscount = payload
  },
  SET_DISCOUNT_FOR_EKIOSK_EDIT: (state, payload) => {
    state.discounts = payload
    // Find general discount with lowest value
    if (payload && payload.length > 0) {
      const generalDiscounts = payload.filter(discount => discount.status === 'General')
      if (generalDiscounts.length > 0) {
        // Sort by value in ascending order and take the first one (lowest value)
        const lowestGeneralDiscount = generalDiscounts.sort((a, b) => a.value - b.value)[0]
        state.generalDiscount = lowestGeneralDiscount
      }
    }
    // Find the discount with highest value that is not a General discount
    if (payload && payload.length > 0) {
      const nonGeneralDiscounts = payload.filter(discount => discount.status !== 'General')
      if (nonGeneralDiscounts.length > 0) {
        // Sort by value in descending order and take the first one (highest value)
        const highestDiscount = nonGeneralDiscounts.sort((a, b) => b.value - a.value)[0]
        state.maxDiscount = highestDiscount
      } else {
        state.maxDiscount = null
      }
    } else {
      state.maxDiscount = null
    }
  }
}